"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var RadioGroup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RadioGroup, _Component);

  function RadioGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RadioGroup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioGroup).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      validationState: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onValidationChange", function (validationState) {
      var onInvalid = _this.props.onInvalid;

      _this.setState({
        validationState: validationState
      });

      if (onInvalid) {
        onInvalid(validationState);
      }
    });

    if (!props.id) {
      throw new Error("The prop 'id' is required to make RadioGroup accessible for users using assistive technologies such as screen readers. Check the render method of RadioGroup.");
    }

    return _this;
  }

  (0, _createClass2.default)(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          id = _this$props.id,
          children = _this$props.children,
          name = _this$props.name,
          label = _this$props.label,
          required = _this$props.required,
          disabled = _this$props.disabled,
          error = _this$props.error,
          onChange = _this$props.onChange;
      var validationState = this.state.validationState;
      var isValid = validationState ? validationState.valid : true;
      var classes = (0, _classnames.default)('RadioGroup', 'FormElement', {
        'FormElement-contains-error': !isValid
      }, className);
      return _react.default.createElement("fieldset", {
        className: classes,
        id: "RadioGroup-".concat(id)
      }, _react.default.createElement("div", {
        className: "FormElement-control-container",
        role: "radiogroup"
      }, label, _react.Children.map(children, function (child, i) {
        return (0, _react.cloneElement)(child, {
          name: name,
          disabled: disabled,
          required: required,
          onChange: onChange,
          id: "".concat(id, "-item-").concat(i),
          onValidationChange: _this2._onValidationChange
        });
      })), !isValid && error);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return RadioGroup;
}(_react.Component);

exports.default = RadioGroup;
(0, _defineProperty2.default)(RadioGroup, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique ID which is used to identify this element for accessibility purposes on the client as well as the server. */
  id: _propTypes.default.string.isRequired,

  /** Children should only be made up of Radio components. */
  children: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,

  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for validation bindings and is required. The name will be passed down to child Radio components to set the proper value upon selection. */
  name: _propTypes.default.string.isRequired,

  /** Whether to disable all the Radio items in this group. */
  disabled: _propTypes.default.bool,

  /** A custom label (typically a Label component) to display next to the radio. */
  label: _propTypes.default.element,

  /** Whether this field is required during validation. */
  required: _propTypes.default.bool,

  /** A custom validation error (typically a FormElementError component) to display when this component is part of a form and is invalid. */
  error: _propTypes.default.element,

  /**
   * Function to execute when the selected state changes.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onChange: _propTypes.default.func,

  /**
   * Function to execute when the element is marked as invalid by a validation check.
   *
   * @param {ValidityState} validationState - ValidityState object for more fine grained control over error handling in a parent component if desired.
   */
  onInvalid: _propTypes.default.func
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RadioGroup, "RadioGroup", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Radio/RadioGroup.jsx");
  leaveModule(module);
})();

;